export default __webpack_public_path__ + "static/media/organisasi.dd8f51f1.png";